"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSummaryProvider = exports.useErrorSummary = exports.ErrorSummaryContext = void 0;
const react_1 = __importStar(require("react"));
const ERROR_MESSAGE = "Wrap your form component in the ErrorSummaryProvider";
const emptyErrorList = {};
exports.ErrorSummaryContext = (0, react_1.createContext)({
    errors: [],
    errorsByKey: {},
    addError: () => {
        console.error(ERROR_MESSAGE);
    },
    addMultipleErrors: () => {
        console.error(ERROR_MESSAGE);
    },
    addMultipleErrorsByKey: () => {
        console.error(ERROR_MESSAGE);
    },
    clearAllErrors: () => {
        console.error(ERROR_MESSAGE);
    },
    clearSingleError: () => {
        console.error(ERROR_MESSAGE);
    },
});
function ErrorSummaryProvider({ children }) {
    const [errors, setErrors] = (0, react_1.useState)({});
    const addError = (error) => {
        setErrors((errors) => (Object.assign(Object.assign({}, errors), { [error.id]: error })));
    };
    const addMultipleErrors = (errors) => {
        setErrors((initialErrors) => (Object.assign(Object.assign({}, initialErrors), errors.reduce((errorsByKey, error) => {
            errorsByKey[error.id] = error;
            return errorsByKey;
        }, emptyErrorList))));
    };
    const addMultipleErrorsByKey = (errors) => {
        setErrors((initialErrors) => (Object.assign(Object.assign({}, initialErrors), errors)));
    };
    const clearAllErrors = () => {
        setErrors({});
    };
    const clearSingleError = (errorKey) => {
        setErrors((errors) => {
            if (!!errors[errorKey]) {
                const _a = errors, _b = errorKey, _error = _a[_b], newErrors = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return newErrors;
            }
            console.error(`The provided key: ${errorKey} does not exist on errors`);
            return errors;
        });
    };
    return (react_1.default.createElement(exports.ErrorSummaryContext.Provider, { value: {
            addError,
            addMultipleErrors,
            addMultipleErrorsByKey,
            clearAllErrors,
            clearSingleError,
            errors: Object.values(errors),
            errorsByKey: errors,
        } }, children));
}
exports.ErrorSummaryProvider = ErrorSummaryProvider;
const useErrorSummary = () => (0, react_1.useContext)(exports.ErrorSummaryContext);
exports.useErrorSummary = useErrorSummary;
//# sourceMappingURL=ErrorSummaryContext.js.map